export const MERCHANT_SERVICE_PROVIDER_PERMISSIONS = {
  LIST: 'merchant-service-provider-list',
  CREATE: 'merchant-service-provider-create',
  VIEW: 'merchant-service-provider-view',
  EDIT: 'merchant-service-provider-edit',
  DELETE: 'merchant-service-provider-delete',
  PERMANENT_DELETE: 'merchant-service-provider-permanent-delete',
  RESTORE: 'merchant-service-provider-restore',
  EXPORT: 'merchant-service-provider-export',
};

export const MERCHANT_SERVICE_PROVIDER_LIST_ACCESS = [
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.LIST,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.CREATE,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.VIEW,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.EDIT,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.DELETE,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.PERMANENT_DELETE,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.RESTORE,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.EXPORT,
];

export const MERCHANT_SERVICE_PROVIDER_VIEW_ACCESS = [
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.VIEW,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.LIST,
  MERCHANT_SERVICE_PROVIDER_PERMISSIONS.EDIT,
];
